import React from 'react';
import {
  CartBtn, TabContent, StoreFooter
} from './ThemeLayoutHelpers';

export default function ModernLayout({ p }) {
  const T = p.storeTheme || {};
  const navColor = T.buttonColor || T.primaryColor || "#059669";
  return (
    <div className="min-h-screen flex flex-col" style={{ ...p.themeStyles, fontFamily: T.fontFamily || "Poppins" }}>
      <nav className="sticky top-0 z-40 text-white" style={{ backgroundColor: navColor }}>
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <p className="font-bold">{p.storeInfo?.businessName}</p>
          <CartBtn p={p} />
        </div>
      </nav>
      <div className="max-w-7xl mx-auto w-full px-4 py-6"><TabContent p={p} /></div>
      <StoreFooter p={p} />
    </div>
  );
}